import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import ListMiniCards from 'generic/ListMiniCards';
import { useStores } from 'hooks/useStores';
import isEmpty from 'lodash/isEmpty';
import { RelatedStyles, Header } from './RelatedStyles';

const Related = observer(() => {
  const {
    advertsStore: {
      currentAdvert: { advert_type, proposal_type, _id },
    },
    relatedStore: { getRelatedTrucks, relatedAdverts, relatedAccounts, status },
  } = useStores();

  useEffect(() => {
    getRelatedTrucks({ advertId: _id });
  }, [_id]);

  if (isEmpty(relatedAdverts)) return null;

  return (
    <RelatedStyles>
      <Header>Похожие объявления</Header>
      <div className="hr" />
      <ListMiniCards
        adverts={relatedAdverts.slice(0, 5)}
        accounts={relatedAccounts}
        loading={status.isRequest}
      />
    </RelatedStyles>
  );
});

export default Related;
